var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportImageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 61,
    height: 61,
    rx: 30.5,
    fill: "#FFF3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8 27.5H31.75V31.94L33.82 29.87C33.97 29.72 34.16 29.65 34.35 29.65C34.54 29.65 34.73 29.72 34.88 29.87C35.17 30.16 35.17 30.64 34.88 30.93L31.53 34.28C31.24 34.57 30.76 34.57 30.47 34.28L27.12 30.93C26.83 30.64 26.83 30.16 27.12 29.87C27.41 29.58 27.89 29.58 28.18 29.87L30.25 31.94V27.5H26.2C23 27.5 21 29.5 21 32.7V35.29C21 38.5 23 40.5 26.2 40.5H35.79C38.99 40.5 40.99 38.5 40.99 35.3V32.7C41 29.5 39 27.5 35.8 27.5Z",
    fill: "#FF627D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 21.25C31.75 20.84 31.41 20.5 31 20.5C30.59 20.5 30.25 20.84 30.25 21.25V27.5H31.75V21.25Z",
    fill: "#FF627D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportImageIcon);
export default __webpack_public_path__ + "static/media/export-image-icon.8f097ff4a200761fcee02956710157d6.svg";
export { ForwardRef as ReactComponent };